(function() {
angular.module('pgtocartaocobrancas')
  .component('pagtocartaocobrancasComponent', {
    templateUrl: 'js/custom-components/pgto-cartao-cobranca/pgtocartaocobrancas.component.html',
    bindings: {
        titleCard: "=",
        columns: "=",
        itens: "=",
        enableCheckbox: "=",
        cardItemStyle: "=",
        filterSearch: "=",
        forceCard: "=",
        cardHint: "=",
        hideTitleBar: "=",
        onSelect: "<",
        messageNull: "=",
        insideFilter: "="
    },
    controller: 'PgtoCartaoCobrancasComponentController',
    controllerAs: 'vm'
  });

})();
